<template>
  <section class="text-center">
    <div class="d-flex align-items-center justify-content-center pb-5">
      <template v-for="(stat, index) in computedStatus">
        <div
          class="d-flex flex-column position-relative"
          :key="`icon-container-${index}`"
        >
          <div
            class="
              icon-container
              rounded-circle
              d-inline-flex
              align-items-center
              justify-content-center
            "
            :style="{ backgroundColor: stat.completed && stat.completedColor }"
          >
            <b-img v-if="stat.icon" :src="stat.icon" class="status-image" />
            <template v-else>
              <OrderStatusPending
                v-if="stat.status === 'pending'"
                :completed="stat.completed"
              />
              <OrderStatusProgressing
                v-if="stat.status === 'in_process'"
                :completed="stat.completed"
              />
              <OrderStatusDispatched
                v-if="stat.status === 'dispatched' || stat.status === 'pick_up'"
                :completed="stat.completed"
              />
              <OrderStatusDelivered
                v-if="stat.status === 'delivered' || stat.status === 'claimed'"
                :completed="stat.completed"
              />
            </template>
          </div>
          <label class="status-label text-center position-absolute">
            {{ stat.label }}
          </label>
        </div>
        <div
          class="status-connector-container position-relative w-auto"
          :key="`status-connector-${index}`"
          v-if="index < 3"
        >
          <StatusConnector :completed="computedStatus[index + 1].completed" />
        </div>
      </template>
    </div>
    <div class="py-3">
      <strong class="status-activity"> {{ computedStatusActivity }} </strong>
    </div>
  </section>
</template>

<script>
import OrderStatusPending from "./order_status_icons/OrderStatusPending";
import OrderStatusProgressing from "./order_status_icons/OrderStatusProcessing";
import OrderStatusDispatched from "./order_status_icons/OrderStatusDispatched";
import OrderStatusDelivered from "./order_status_icons/OrderStatusDelivered";
import StatusConnector from "./order_status_icons/StatusConnector";
import { mapGetters } from "vuex";

const primaryColor = "#00afaa";

export default {
  props: ["status", "orderType"],
  components: {
    OrderStatusPending,
    OrderStatusProgressing,
    OrderStatusDispatched,
    OrderStatusDelivered,
    StatusConnector
  },
  data() {
    return {
      orderStatus: {
        pending: {
          level: 0,
          completed: false,
          label: "Pending",
          status: "pending",
          activity: "Your order is pending.",
          completedColor: primaryColor,
          icon: ""
        },
        processing: {
          level: 1,
          completed: false,
          label: "Processing",
          status: "in_process",
          activity: "Your order is procesing.",
          completedColor: primaryColor,
          icon: ""
        }
      }
    };
  },
  computed: {
    ...mapGetters("design", [
      "pendingDesign",
      "processingDesign",
      "dispatchedDesign",
      "pickupDesign",
      "deliveredDesign",
      "claimedDesign"
    ]),
    computedStatus: {
      get() {
        const level = Object.values(this.orderStatus).find(
          status => status.status === this.status
        ).level;
        return Object.values(this.orderStatus).map(status => {
          status.completed = status.level <= level;
          return status;
        });
      },
      set(status) {
        return status;
      }
    },
    computedStatusActivity: {
      get() {
        return Object.values(this.orderStatus).find(
          stat => stat.status === this.status
        ).activity;
      },
      set(activity) {
        return activity;
      }
    }
  },
  created() {
    if (this.orderType.toLowerCase().includes("pick")) {
      this.orderStatus = {
        ...this.orderStatus,
        pickup: {
          level: 2,
          completed: false,
          label: "Pickup",
          status: "pick_up",
          activity: "Your order is ready for pickup.",
          completedColor: primaryColor,
          icon: ""
        },
        claimed: {
          level: 3,
          completed: false,
          label: "Claimed",
          status: "claimed",
          activity: "Your order has been claimed.",
          completedColor: primaryColor,
          icon: ""
        }
      };
    } else {
      this.orderStatus = {
        ...this.orderStatus,
        dispatched: {
          level: 2,
          completed: false,
          label: "Dispatched",
          status: "dispatched",
          activity: "Your order is on the way.",
          completedColor: primaryColor,
          icon: ""
        },
        delivered: {
          level: 3,
          completed: false,
          label: "Delivered",
          status: "delivered",
          activity: "Your order has been delivered.",
          completedColor: primaryColor,
          icon: ""
        }
      };
    }

    for (const key of Object.keys(this.orderStatus)) {
      const design = this[`${key}Design`];

      if (design) {
        if (design.status_color)
          this.orderStatus[key].completedColor = design.status_color;

        if (design.status_icon) this.orderStatus[key].icon = design.status_icon;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-container {
  width: 48px;
  height: 48px;
  background: #edeef0;
}
.status-connector-container {
  left: 2px;
}
.status-label {
  min-width: 82px;
  bottom: -40px;
  text-indent: -37%;
}
.status-image {
  height: 25px;
  width: 25px;
}
</style>
